<template>
    <div class="bg-white px-3" style="margin-bottom: 0!important;">
        <div class="pd" v-loading="loading">
            <!-- 公众号设置 -->
            <el-row class="btm">
                <el-col :span="24">
                    <span>公众号: </span>
                    <el-select v-model="gzh_value" size="small" placeholder="请选择" @change="gzhchange">
                        <el-option v-for="item in gzh_options" :key="item.source" :label="item.name"
                            :value="item.source">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="24" type="flex">
                <el-col :span="24" class="ml40">
                    <el-col :span="24">
                        <el-col :xl="7" :lg="7" :md="22" :sm="22" :xs="22" class="left mb15">
                            <img class="top" src="../../assets/imgs/mobilehead.png" />
                            <img class="bottom" src="../../assets/imgs/mobilefoot.png" />
                            <div class="centent">
                                <div class="time-wrapper"><span class="time">9:36</span></div>
                                <div class="view-item text-box clearfix" v-if="formValidate.type !== 'news'">
                                    <div class="avatar fl"><img src="../../assets/imgs/head.gif" /></div>
                                    <div class="box-content fl">
                                        <span v-text="formValidate.data.content"
                                            v-if="formValidate.type === 'text'"></span>
                                        <div class="box-content_pic" v-if="formValidate.data.src">
                                            <img :src="formValidate.data.src?formValidate.data.src:''">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="formValidate.type === 'news'">
                                    <div v-for="(j, i) in formValidate.data.list" :key="i">
                                        <div v-if="i === 0">
                                            <div class="news_pic"
                                                :style="{backgroundImage: 'url(' + (j.image_input[0]) + ')',backgroundSize:'100% 100%'}">
                                            </div>
                                            <span class="news_sp">{{j.title}}</span>
                                        </div>
                                        <div v-else class="news_cent">
                                            <span class="news_sp1" v-if="j.synopsis">{{j.title}}</span>
                                            <div class="news_cent_img" v-if="j.image_input.length!==0"><img
                                                    :src="j.image_input[0]"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :xl="11" :lg="12" :md="22" :sm="22" :xs="22">
                            <el-col :span="24" class="userAlert">
                                <div class="box-card right">
                                    <el-form ref="formValidate" :model="formValidate" :rules="ruleValidate"
                                        label-width="100px" class="mt20">
                                        <el-form-item label="消息状态：">
                                            <el-radio-group v-model="formValidate.status">
                                                <el-radio :label="0">启用</el-radio>
                                                <el-radio :label="1">禁用</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="消息类型：" prop="type">
                                            <el-select v-model="formValidate.type" placeholder="请选择规则状态" size="small"
                                                @on-change="RuleFactor(formValidate.type)">
                                                <el-option value="text" label="文字消息">文字消息</el-option>
                                                <el-option value="image" label="图片消息">图片消息</el-option>
                                                <el-option value="news" label="文章消息">文章消息</el-option>
                                                <el-option value="sketch" label="图文消息">图文消息</el-option>
                                                <!-- <el-option value="voice" label="声音消息">声音消息</el-option>  -->
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="消息内容：" prop="content" v-if="formValidate.type === 'text'">
                                            <el-input v-model="formValidate.data.content" type="textarea" :rows="4"
                                                placeholder="请填写消息内容" size="small"></el-input>
                                        </el-form-item>


                                        <el-form-item label="图片" prop="image_url"
                                            v-if="formValidate.type == 'image'||formValidate.type == 'sketch'">
                                            <span v-if="!formValidate.image_url" class="btn btn-light border mr-2"
                                                @click="pos_chooseImage">
                                                <i class="el-icon-plus"></i>
                                            </span>
                                            <img v-else :src="formValidate.image_url" class="rounded"
                                                style="width: 45px;height: 45px;cursor: pointer;"
                                                @click="pos_chooseImage" />
                                        </el-form-item>



                                        <el-form-item label="图文：" v-if="formValidate.type == 'news'" prop="tuwen_name">
                                            <el-button size="small" @click="optuwen" type="primary">选择文章</el-button>
                                            <div>{{formValidate.tuwen_name?formValidate.tuwen_name:'未选择'}}</div>
                                        </el-form-item>

                                        <el-form-item label="消息：" v-if="formValidate.type == 'sketch'">
                                            <el-form-item :label="'消息'+(i+1)" required
                                                v-for="(c,i) in formValidate.rwb_contents" :key="i" label-width="70px">
                                                <div class="con_s">
                                                    <el-input v-model="c.content" placeholder="请填写消息内容" type="textarea"
                                                        style="max-width:400px" :rows="4" size="small"></el-input>
                                                    <div class="con_a_btn">
                                                        <el-button @click="del_cons(i)" v-if="i>0" size="small"
                                                            icon="el-icon-remove-outline" circle></el-button>
                                                        <el-button @click="add_cons()" size="small" type="primary"
                                                            icon="el-icon-circle-plus-outline" circle>
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </el-form-item>

                                        </el-form-item>

                                    </el-form>

                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="acea-row row-center">
                                    <el-button type="primary" class="mr20" :loading="subloading"
                                        @click="submenus('formValidate')">保存并发布
                                    </el-button>
                                </div>
                            </el-col>
                        </el-col>
                    </el-col>
                </el-col>
            </el-row>
        </div>
        <el-dialog title="选择图文" center :visible.sync="dialog_tuwen" width="60%" top="80px" class="dialogs">
            <el-divider></el-divider>
            <tuwen @selecttuwen="selects" />
            <el-divider></el-divider>

        </el-dialog>

    </div>
</template>

<script>
    import tuwen from "./tuwen.vue";
    export default {
        name: 'follow',
        inject: ['app'],
        props: ['url'],
        components: {
            tuwen
        },
        data() {
            const validateContent = (rule, value, callback) => {
                if (this.formValidate.type === 'text') {
                    if (this.formValidate.data.content === '') {
                        callback(new Error('请填写规则内容'))
                    } else {
                        callback()
                    }
                }
            }
            const validateSrc = (rule, value, callback) => {
                if (this.formValidate.type === 'image' && this.formValidate.data.src === '') {
                    callback(new Error('请上传'))
                } else {
                    callback()
                }
            }
            return {
                formatImg: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
                formatVoice: ['mp3', 'wma', 'wav', 'amr'],
                headers: {
                    token: null
                },
                eid: '',
                loading: false,
                formValidate: {
                    status: 0,
                    type: '',
                    data: {
                        content: '',
                        src: '',
                        list: []
                    },
                    image_url2: '',
                    image_url: '',
                    tuwen_name: '',
                    tuwen_id: '',
                    rwb_contents: [{
                        content: ''
                    }]
                },
                // fileUrl: Setting.apiBaseURL + '/file/upload/1',
                ruleValidate: {
                    type: [{
                        required: true,
                        message: '请选择消息类型',
                        trigger: 'change'
                    }],
                    content: [{
                        required: true,
                        validator: validateContent,
                        trigger: 'blur'
                    }],
                    src: [{
                        required: true,
                        validator: validateSrc,
                        trigger: 'change'
                    }],
                    image_url: [{
                        required: true,
                        message: '请选择图片',
                        trigger: 'blur'
                    }],
                    tuwen_name: [{
                        required: true,
                        message: '请选择文章',
                        trigger: 'blur'
                    }],
                },
                gzh_value: '',
                gzh_options: [],
                gzh_appid: '',
                dialog_tuwen: false,
                subloading: false,
            }
        },
        mounted() {
            this.headers.token = this.$store.state.user.token
            this.getselects()
            // 
        },
        methods: {
            // 获取下拉框
            getselects() {
                axios.post('/admin/wechat.index/gzhConfig', {}, {
                    token: true
                }).then(res => {
                    if (res.data.data) {
                        this.gzh_options = res.data.data.filter(a=>a.appid!='wx10dde7d68a3a2239')
                        this.gzh_value = res.data.data[0].source
                        this.gzh_appid = res.data.data[0].appid
                        this.details()
                    } else {
                        this.gzh_options = []
                    }
                }).catch(err => {})
            },

            gzhchange(index) {
                this.gzh_options.forEach(ele => {
                    if (ele.source == index) {
                        this.gzh_appid = ele.appid
                    }
                })
                this.details()
            },
            // 详情
            details() {
                this.loading = true
                axios
                    .post(this.url, {
                        source: this.gzh_value,
                        appid: this.gzh_appid
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.loading = false
                        var data = response.data.data.data
                        if (data) {
                            this.eid = data.id
                            this.formValidate.name = data.keys
                            this.formValidate.type = data.type
                            this.formValidate.status = data.status

                            this.formValidate.data = {
                                content: data.content,
                                src: '',
                                list: []
                            }
                            this.formValidate.tuwen_name = data.news_title
                            this.formValidate.tuwen_id = data.news_id
                            this.formValidate.image_url2 = data.image_url
                            this.formValidate.image_url = data.url
                            if (data.type == 'sketch') {
                                this.formValidate.rwb_contents = data.content
                            }
                        } else {
                            this.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            add_cons() {
                this.formValidate.rwb_contents.push({
                    content: ''
                })
            },
            del_cons(i) {
                this.formValidate.rwb_contents.splice(i, 1)
            },
            // 下拉选择
            RuleFactor(type) {
                return
                switch (type) {
                    case 'text':
                        this.formValidate.data.src = ''
                        this.formValidate.data.list = []
                        break
                    case 'news':
                        this.formValidate.data.src = ''
                        this.formValidate.data.content = ''
                        break
                    default:
                        this.formValidate.data.list = []
                        this.formValidate.data.content = ''
                        this.formValidate.data.src = ''
                }
            },
            // 上传成功
            handleSuccess(res, file) {
                if (res.status === 200) {
                    this.formValidate.data.src = res.data.src
                    this.$Message.success(res.msg)
                } else {
                    this.$Message.error(res.msg)
                }
            },
            handleFormatError(file) {
                if (this.formValidate.type === 'image') {
                    this.$Message.warning('请上传bmp/png/jpeg/jpg/gif格式的图片')
                } else {
                    this.$Message.warning('请上传mp3/wma/wav/amr格式的语音')
                }
            },
            handleMaxSize(file) {
                this.$Message.warning('请上传文件2M以内的文件')
            },
            pos_chooseImage() {
                this.app.chooseImage((res) => {
                    this.formValidate.image_url = res[0].url
                    this.formValidate.image_url2 = res[0].local_url
                }, 1, '', '', 1)
            },
            optuwen() {
                this.dialog_tuwen = true
            },
            selects(o) {
                this.formValidate.tuwen_name = o.name
                this.formValidate.tuwen_id = o.id
                this.dialog_tuwen = false
            },
            // 保存
            submenus(name) {
                let that = this
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.formValidate.type == 'sketch') {
                            let a = 0
                            for (let i = 0; i < this.formValidate.rwb_contents.length; i++) {
                                const e = this.formValidate.rwb_contents[i];
                                if (e.content == '') {
                                    a = 1
                                    break
                                }
                            }
                            if (a == 1) return this.$message('消息未填写完整！')
                        }
                        that.subloading = true
                        axios
                            .post(this.url, {
                                id: this.eid,
                                status: this.formValidate.status,
                                type: this.formValidate.type,
                                content: this.formValidate.type == 'sketch' ? this.formValidate
                                    .rwb_contents : this.formValidate.data.content,
                                image_url: this.formValidate.image_url2,
                                file: '',
                                op: "edit",
                                source: this.gzh_value,
                                appid: this.gzh_appid,
                                news_id: this.formValidate.tuwen_id,

                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == 200) {
                                    this.details()
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功!'
                                    });
                                } else {

                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .pd {
        padding: 30px 10px 40px;
    }

    .btm {
        margin-bottom: 20px;
    }

    * {
        -moz-user-select: none;
        /*火狐*/
        -webkit-user-select: none;
        /*webkit浏览器*/
        -ms-user-select: none;
        /*IE10*/
        -khtml-user-select: none;
        /*早期浏览器*/
        user-select: none;
    }

    .left {
        min-width: 390px;
        min-height: 550px;
        position: relative;
        padding-left: 40px;
    }

    .top {
        position: absolute;
        top: 0px;
    }

    .bottom {
        position: absolute;
        bottom: 0px;
    }

    .centent {
        background: #F4F5F9;
        min-height: 438px;
        position: absolute;
        top: 63px;
        width: 320px;
        padding: 15px;
        box-sizing: border-box;
    }

    .right {
        background: #fff;
        min-height: 300px;
    }

    .box-content {
        position: relative;
        max-width: 60%;
        min-height: 40px;
        margin-left: 15px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px solid #ccc;
        word-break: break-all;
        word-wrap: break-word;
        line-height: 1.5;
        border-radius: 5px;
    }

    .box-content_pic {
        width: 100%;
    }

    .box-content_pic img {
        width: 100%;
        height: auto;
    }

    .box-content:before {
        content: '';
        position: absolute;
        left: -13px;
        top: 11px;
        display: block;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 10px solid #ccc;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .box-content:after {
        content: '';
        content: '';
        position: absolute;
        left: -12px;
        top: 11px;
        display: block;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 10px solid #f5f5f5;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .time-wrapper {
        margin-bottom: 10px;
        text-align: center;
    }

    .time {
        display: inline-block;
        color: #f5f5f5;
        background: rgba(0, 0, 0, .3);
        padding: 3px 8px;
        border-radius: 3px;
        font-size: 12px;
    }

    .text-box {
        display: flex;
    }

    .avatar {
        width: 40px;
        height: 40px;
    }

    .avatar img {
        width: 100%;
        height: 100%;
    }

    .modelBox>>>.ivu-modal-body {
        padding: 0 16px 16px 16px !important
    }

    .news_pic {
        width: 100%;
        height: 150px;
        overflow: hidden;
        position: relative;
        background-size: 100%;
        background-position: center center;
        border-radius: 5px 5px 0 0;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .news_sp {
        font-size: 12px;
        color: #000000;
        background: #fff;
        width: 100%;
        height: 38px;
        line-height: 38px;
        padding: 0 12px;
        box-sizing: border-box;
        display: block;
    }

    .news_cent {
        width: 100%;
        height: auto;
        background: #fff;
        border-top: 1px dashed #eee;
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        justify-content: space-between;

        .news_sp1 {
            font-size: 12px;
            color: #000000;
            width: 71%;
            ;
        }

        .news_cent_img {
            width: 81px;
            height: 46px;
            border-radius: 6px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .row-center {
        text-align: center;
    }
</style>